import React, { lazy } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, InstagramIcon, FacebookIcon, YoutubeIcon, ClockIcon, MessageSquareIcon } from 'lucide-react';
export function Contact() {
  return <div className="w-full bg-white" data-id="element-455">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-456">
        <div className="max-w-7xl mx-auto text-center" data-id="element-457">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-458">
            Contact Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-459">
            Get in touch with our team for appointments, course inquiries, or
            general questions
          </p>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-460">
        <div className="max-w-7xl mx-auto" data-id="element-461">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-462">
            <div data-id="element-463">
              <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-464">
                Get In Touch
              </h2>
              <div className="space-y-6" data-id="element-465">
                <div className="flex items-start" data-id="element-466">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-467">
                    <MapPinIcon className="w-6 h-6 text-blue-600" data-id="element-468" />
                  </div>
                  <div data-id="element-469">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-470">
                      Our Location
                    </h3>
                    <p className="text-gray-700" data-id="element-471">
                      Aatmshakti Institute of Integrated Medical Research
                      <br data-id="element-472" />
                      Plot No. 24, Sector B–7, Talkatora Road
                      <br data-id="element-473" />
                      Gomti Nagar Extension
                      <br data-id="element-474" />
                      Lucknow, Uttar Pradesh 226010, India
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-475">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-476">
                    <PhoneIcon className="w-6 h-6 text-teal-600" data-id="element-477" />
                  </div>
                  <div data-id="element-478">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-479">
                      Phone & WhatsApp
                    </h3>
                    <a href="tel:+918303699990" className="text-blue-600 hover:underline block" data-id="element-480">
                      +91 83036 99990
                    </a>
                    <a href="https://wa.me/918303699990" className="inline-flex items-center text-green-600 hover:underline mt-2" data-id="element-481">
                      <MessageSquareIcon className="w-4 h-4 mr-1" data-id="element-482" />
                      Message us on WhatsApp
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-483">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-484">
                    <MailIcon className="w-6 h-6 text-purple-600" data-id="element-485" />
                  </div>
                  <div data-id="element-486">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-487">Email</h3>
                    <a href="mailto:amit.kapoor@aiimr.in" className="text-blue-600 hover:underline" data-id="element-488">
                      amit.kapoor@aiimr.in
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-489">
                  <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-490">
                    <ClockIcon className="w-6 h-6 text-pink-600" data-id="element-491" />
                  </div>
                  <div data-id="element-492">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-493">
                      Business Hours
                    </h3>
                    <p className="text-gray-700" data-id="element-494">
                      Monday - Saturday: 9:00 AM - 6:00 PM
                      <br data-id="element-495" />
                      Sunday: By Appointment Only
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-496">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-497">
                  Follow Us On Social Media
                </h3>
                <div className="flex space-x-4" data-id="element-498">
                  <a href="https://www.instagram.com/aethe.aiimr/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center hover:shadow-lg transition-shadow" data-id="element-499">
                    <InstagramIcon className="w-6 h-6 text-white" data-id="element-500" />
                  </a>
                  <a href="https://www.facebook.com/aethe.aiimr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center hover:shadow-lg transition-shadow" data-id="element-501">
                    <FacebookIcon className="w-6 h-6 text-white" data-id="element-502" />
                  </a>
                  <a href="https://www.youtube.com/@aiimraethe" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center hover:shadow-lg transition-shadow" data-id="element-503">
                    <YoutubeIcon className="w-6 h-6 text-white" data-id="element-504" />
                  </a>
                </div>
              </div>
            </div>
            <div data-id="element-505">
              <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-506">
                Find Us On Map
              </h2>
              <div className="bg-gray-100 rounded-xl overflow-hidden shadow-lg" data-id="element-507">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.123456789!2d80.9876543!3d26.8765432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDUyJzM1LjYiTiA4MMKwNTknMTUuNiJF!5e0!3m2!1sen!2sin!4v1234567890" width="100%" height="450" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="AIIMR Location" data-id="element-508"></iframe>
              </div>
              <div className="mt-4 text-center" data-id="element-509">
                <a href="https://maps.app.goo.gl/ekXgB6TptCKHzKXt9" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 hover:underline font-medium" data-id="element-510">
                  <MapPinIcon className="w-4 h-4 mr-2" data-id="element-511" />
                  Open in Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-green-50 to-teal-50 w-full" data-id="element-512">
        <div className="max-w-7xl mx-auto" data-id="element-513">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-514">
            <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-515">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-516">
                Online Treatment Consultation
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-517">
                Can't visit us in person? Get expert treatment recommendations
                online! Fill out our comprehensive health assessment form and
                upload your tongue picture and latest medical reports.
              </p>
              <div className="bg-green-50 p-6 rounded-xl mb-6" data-id="element-518">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-519">
                  What You Need:
                </h3>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-520">
                  <li className="flex items-start" data-id="element-521">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-3 flex-shrink-0" data-id="element-522"></div>
                    <span data-id="element-523">
                      Clear photograph of your tongue (natural lighting, no
                      filter)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-524">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-3 flex-shrink-0" data-id="element-525"></div>
                    <span data-id="element-526">Recent medical reports and test results</span>
                  </li>
                  <li className="flex items-start" data-id="element-527">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-3 flex-shrink-0" data-id="element-528"></div>
                    <span data-id="element-529">Detailed health history information</span>
                  </li>
                  <li className="flex items-start" data-id="element-530">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-3 flex-shrink-0" data-id="element-531"></div>
                    <span data-id="element-532">WhatsApp number for receiving recommendations</span>
                  </li>
                </ul>
              </div>
              <a href="https://treatment.aiimr.in/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center bg-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-lg" data-id="element-533">
                <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-534" />
                Fill Online Treatment Form
              </a>
            </div>
            <div data-id="element-535">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-536">
                How Online Treatment Works
              </h3>
              <div className="space-y-6" data-id="element-537">
                <div className="flex items-start" data-id="element-538">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-539">
                    <span className="text-xl font-bold text-green-600" data-id="element-540">1</span>
                  </div>
                  <div data-id="element-541">
                    <h4 className="font-semibold text-gray-900 mb-2" data-id="element-542">
                      Complete the Form
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-543">
                      Fill out our detailed health assessment questionnaire with
                      your symptoms, medical history, and current concerns.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-544">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-545">
                    <span className="text-xl font-bold text-green-600" data-id="element-546">2</span>
                  </div>
                  <div data-id="element-547">
                    <h4 className="font-semibold text-gray-900 mb-2" data-id="element-548">
                      Upload Documents
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-549">
                      Attach your tongue picture and any relevant medical
                      reports or test results for comprehensive assessment.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-550">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-551">
                    <span className="text-xl font-bold text-green-600" data-id="element-552">3</span>
                  </div>
                  <div data-id="element-553">
                    <h4 className="font-semibold text-gray-900 mb-2" data-id="element-554">
                      Expert Review
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-555">
                      Our experienced practitioners will thoroughly review your
                      submission and analyze your condition using TCM diagnostic
                      principles.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-556">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-557">
                    <span className="text-xl font-bold text-green-600" data-id="element-558">4</span>
                  </div>
                  <div data-id="element-559">
                    <h4 className="font-semibold text-gray-900 mb-2" data-id="element-560">
                      Receive Recommendations
                    </h4>
                    <p className="text-sm text-gray-700" data-id="element-561">
                      Get personalized treatment recommendations, lifestyle
                      guidance, and dietary suggestions via WhatsApp within
                      24-48 hours.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gray-50 w-full" data-id="element-562">
        <div className="max-w-4xl mx-auto" data-id="element-563">
          <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-564">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-565">
              Send Us A Message
            </h2>
            <form className="space-y-6" data-id="element-566">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-567">
                <div data-id="element-568">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-569">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Your name" data-id="element-570" />
                </div>
                <div data-id="element-571">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-572">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="your@email.com" data-id="element-573" />
                </div>
              </div>
              <div data-id="element-574">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-575">
                  Phone Number
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="+91 XXXXX XXXXX" data-id="element-576" />
              </div>
              <div data-id="element-577">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-578">
                  Subject
                </label>
                <select id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-579">
                  <option data-id="element-580">Book Appointment</option>
                  <option data-id="element-581">Course Inquiry</option>
                  <option data-id="element-582">General Question</option>
                  <option data-id="element-583">Other</option>
                </select>
              </div>
              <div data-id="element-584">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-585">
                  Message
                </label>
                <textarea id="message" rows={6} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tell us how we can help you..." data-id="element-586"></textarea>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg" data-id="element-587">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>;
}